import React from 'react';
import './card.css'
import './card2.css'
import star from './../../assets/Star2.svg'
const Review = (props) => {
    return ( 
        <>
        <div className="eventCard reviewCard">
        <p>
        {props.quote}
        </p>
        <div className="reviewFlex">
            <h3>
            {props.name}
            </h3>
            <div className="eventCTA">
                <img src={star} alt="" />
                <h3>{props.rating} stars</h3>
            </div>
        </div>
        </div>
        </>
     );
}
 
export default Review;